import { createContext, useContext, useState } from 'react';

const AdminHeaderContext = createContext({ slot: null, setSlot: () => {} });

export function AdminHeaderProvider({ children }) {
    const [slot, setSlot] = useState(null);
    return (
        <AdminHeaderContext.Provider value={{ slot, setSlot }}>
            {children}
        </AdminHeaderContext.Provider>
    );
}

export const useAdminHeaderSlot = () => useContext(AdminHeaderContext);
